class CinderellaCartItems extends HTMLElement {
  static TITLE_MAX = 16;

  connectedCallback() {
    this.render();
  }

  render() {
    if (this.dataset.cinderellaRendered) return;

    const raw = this.dataset.cinderellaItems;
    if (!raw) return;

    let items;
    try {
      items = JSON.parse(raw);
    } catch (error) {
      this.dataset.cinderellaRendered = 'invalid';
      return;
    }

    if (!Array.isArray(items) || items.length === 0) {
      this.dataset.cinderellaRendered = 'empty';
      return;
    }

    const primaryId = this.dataset.cinderellaPrimaryId || '';
    const list = document.createElement('ul');
    list.className = 'cinderella-cart-items__list';

    items.forEach((item) => {
      if (!item) return;
      list.appendChild(this.buildItem(item, primaryId));
    });

    this.replaceChildren(list);
    this.dataset.cinderellaRendered = 'true';
  }

  buildItem(item, primaryId) {
    const listItem = document.createElement('li');
    listItem.className = 'cinderella-cart-items__item';
    if (primaryId && String(item.variant_id) === String(primaryId)) {
      listItem.classList.add('cinderella-cart-items__item--primary');
    }

    const meta = [];
    if (item.color) meta.push(String(item.color));
    if (item.size) meta.push(String(item.size).split(' / ').join(' • '));

    listItem.appendChild(document.createTextNode('- '));

    const container = item.url ? document.createElement('a') : document.createElement('span');
    if (item.url) {
      container.href = item.url;
      container.className = 'cinderella-cart-items__link';
    }

    if (item.title) {
      const title = document.createElement('span');
      title.className = 'cinderella-cart-items__title';
      title.textContent = this.truncate(item.title);
      container.appendChild(title);
    }

    if (meta.length) {
      const metaText = document.createElement('span');
      metaText.className = 'cinderella-cart-items__meta';
      metaText.textContent = `${item.title ? ' • ' : ''}${meta.join(' • ')}`;
      container.appendChild(metaText);
    }

    listItem.appendChild(container);

    return listItem;
  }

  truncate(value) {
    const text = String(value == null ? '' : value);
    if (text.length <= CinderellaCartItems.TITLE_MAX) return text;
    return `${text.slice(0, CinderellaCartItems.TITLE_MAX).trimEnd()}…`;
  }
}

if (!customElements.get('cinderella-cart-items')) {
  customElements.define('cinderella-cart-items', CinderellaCartItems);
}
